import classNames from "classnames";
import { useState } from "react";
import FadeIn from "../../../../../../src/vendored/FadeIn";
import { FADE_IN_ANIMATION_DURATION } from "../../../dashboard_utils";
import { trpc } from "../../../utils/trpc";
import { BoxItem } from "../box_item";

export function BlurbBanner() {
	const [isDismissed, setIsDismissed] = useState(false);
	const utils = trpc.useContext();
	const activeBlurbQuery = trpc.blurb.getActiveBlurb.useQuery();
	const dismissBlurbMutation = trpc.blurb.dismissBlurb.useMutation({
		onSuccess: () => {
			utils.blurb.getActiveBlurb.invalidate();
		},
	});

	// Don't show anything while loading or if no active blurb
	if (!activeBlurbQuery.isSuccess || !activeBlurbQuery.data) {
		return null;
	}

	const { id, dashboard_message } = activeBlurbQuery.data;

	if (isDismissed) {
		return null;
	}

	const handleDismiss = async () => {
		try {
			await dismissBlurbMutation.mutateAsync({ blurb_id: id });
			setIsDismissed(true);
		} catch (error) {
			console.error("Failed to dismiss blurb:", error);
		}
	};

	// is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd
	// w-11/12 md:w-3/4 lg:w-3/4 xl:w-1/2 2xl:w-2/5

	return (
		<FadeIn transitionDuration={FADE_IN_ANIMATION_DURATION}>
			<div className="z-[11] mb-6 flex w-full items-center justify-center gap-2">
				<BoxItem
					bgColor="semidark"
					className="column is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd border border-sesh-dark"
				>
					<div className="relative flex w-full min-w-[256px] items-start justify-between p-4 ">
						<button
							onClick={handleDismiss}
							className={classNames(
								"absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full",
								"bg-base-dark/10 hover:bg-base-dark/20",
								"transition-colors duration-200"
							)}
							aria-label="Dismiss notification"
						>
							<i className="fas fa-times text-sm" />
						</button>
						<div className="flex w-full items-center gap-6">
							<div
								className="mx-auto whitespace-pre-wrap"
								dangerouslySetInnerHTML={{
									__html: dashboard_message,
								}}
							/>
						</div>
					</div>
				</BoxItem>
			</div>
		</FadeIn>
	);
}
